import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@rebass/emotion';
import styled from '@emotion/styled';

import theme from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

import { isSoftwareItem } from './OrderHistoryDetailContext';
import { DetailTable } from './OrderHistoryDetail.styles';
import messages from './ItemsDetail.messages';

import { OrderHistoryDetailItemsQuery_magento2_customer_globalOrders_items_items } from './__generated__/OrderHistoryDetailItemsQuery';

export const ItemDescription: FunctionComponent<{
  item: OrderHistoryDetailItemsQuery_magento2_customer_globalOrders_items_items;
  className?: string;
}> = ({ item, className }) => (
  <span className={className}>
    {item.productName}
    {isSoftwareItem(item) ? (
      <>
        {' ('}
        <FormattedMessage {...messages.itemDownloadableIndicator} />
        {')'}
      </>
    ) : null}
  </span>
);

export const ItemSimplified = styled(Box)`
  border-top: 1px solid ${theme.colors.lightGray};

  &:last-of-type {
    border-bottom: 1px solid ${theme.colors.lightGray};
  }
`;

export const ItemDescriptionSimplified = styled(ItemDescription)`
  font-weight: bold;
`;

export const ItemPricesSimplified = styled.dl`
  display: flex;
  padding: 0;
  margin: 0;

  & dt,
  & dd {
    padding: 0;
    margin: 0;
  }

  & dt {
    font-weight: bold;
    margin-bottom: ${rem(4)};
  }
`;

export const TotalsTableSimplified = styled(DetailTable)`
  padding-bottom: ${rem(20)};
  border-bottom: 1px solid ${theme.colors.lightGray};

  & thead,
  & tbody {
    & tr,
    & tr:last-of-type {
      & th,
      & td {
        border: none;
      }
    }
  }
`;
